import React, { ReactNode } from "react";

import { Grid, ListItemButton } from "@mui/material";
import { ListItemButtonProps } from "@mui/material/ListItemButton/ListItemButton";
import { styled } from "@mui/material/styles";

import { IgTypography } from "./IgTypography";
import { ColorGray, ColorPrimary, ColorSuccess } from "./theme";

interface IgListItemButtonsProps extends ListItemButtonProps {
  label: string | ReactNode;
  igVariant?: "primary" | "success";
  direction?: "row" | "column";
  buttonFontSize?: string;
}
export const IgListItemButton = ({
  label,
  igVariant,
  buttonFontSize,
  direction,
  ...rest
}: IgListItemButtonsProps) => {
  const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
    transition: "0.2s",
    borderRadius: "4px",
    justifyContent: "center",
    border: `1px solid ${ColorGray.light}`,
    "&:hover, &:focus": {
      border: `1px solid ${
        igVariant === "success" ? ColorSuccess.main : ColorPrimary.main
      }`,
    },
    "&:focus": {
      backgroundColor: "transparent",
    },
    "&.Mui-selected": {
      backgroundColor:
        igVariant === "success"
          ? "transparent !important"
          : "rgba(41, 98, 255, 0.08)",
      border: `1px solid ${
        igVariant === "success" ? ColorSuccess.main : ColorPrimary.main
      }`,
    },
  }));

  return (
    <StyledListItemButton {...rest}>
      {/*<Grid container direction={"column"} alignItems={"center"}>*/}
      {/*<Grid item>*/}
      <IgTypography
        variant="body2"
        sx={{ fontWeight: 600, fontSize: buttonFontSize ?? "14px" }}
      >
        {label}
      </IgTypography>
      {/*</Grid>*/}
      {/*</Grid>*/}
    </StyledListItemButton>
  );
};
